/**
 * 骨架屏（M11 UX 打磨，UX 书 §2 交互原语表"骨架屏 Skeleton"+ §4 状态表）：
 * "所有列表与详情的首次加载；结构与真实内容同形，避免布局跳动"、
 * "列表首次加载 → 骨架行（与真实行同高，5–8 行）"、"详情抽屉加载 → 分区骨架"。
 *
 * 两个原语刻意保持极简：
 * - `SkeletonRows`：n 行 × 每行若干条不同宽度的横条，行高由调用方传入
 *   （与真实行同高是 UX 书的硬要求，不能拍一个全局值）。
 * - `SkeletonBlock`：详情页/抽屉的分区占位块。
 *
 * aria-hidden：骨架不是内容，读屏器不应该念它；配套的 aria-busy 由调用方
 * 放在列表容器上（这里不强加，因为容器归属各页面）。
 */

const BAR_WIDTHS = ['24%', '14%', '10%', '12%', '10%', '8%'] as const;

export function SkeletonRows({
  rows = 6,
  rowHeight = 44,
  bars = 5,
}: {
  readonly rows?: number;
  readonly rowHeight?: number;
  readonly bars?: number;
}): React.JSX.Element {
  return (
    <div aria-hidden="true">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skeleton-row" style={{ height: `${rowHeight}px` }}>
          {Array.from({ length: bars }, (_, j) => (
            <span
              key={j}
              className="skeleton"
              style={{
                height: '14px',
                width: BAR_WIDTHS[j % BAR_WIDTHS.length],
                // 首列吃掉剩余空间，模拟"名称列宽、数字列窄"的真实结构
                flex: j === 0 ? 1 : undefined,
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export function SkeletonBlock({
  height = 96,
  width = '100%',
}: {
  readonly height?: number;
  readonly width?: string;
}): React.JSX.Element {
  return (
    <div
      aria-hidden="true"
      className="skeleton"
      style={{ height: `${height}px`, width, marginBottom: 'var(--space-3)' }}
    />
  );
}
